
class CapSubmitOneTimeNoRide {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'submit_one_time_no_ride'
}

function create(config) {
  return new CapSubmitOneTimeNoRide(config)
}

export default {
  key,
  create,
}
